import { styled, Grid } from '@mui/material'

export const StyledGrid = styled(Grid)({
  justifyContent: 'flex-start',
  fontFamily: 'Lato, sans-serif'
})
